module.exports = __webpack_public_path__ + "img/am.5758d3ec.svg";